import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Background = styled.div`
    background: rgba(116, 120, 129, 0.08);
    padding: ${rem(45)} ${rem(20)};
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(30)};
    margin-top: ${rem(40)};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const Section = styled.div`
    background: ${({ theme }) => theme.colors.white};
    border-radius: ${rem(16)};
    padding: ${rem(40)};
    display: flex;
    flex-direction: column;
    @media (min-width: ${breakpoints.sm}px) {
        width: 50%;
    }
`;

export const SectionHeader = styled.div`
    font-size: ${({ theme }) => theme.fontSizes.h4};
    line-height: ${rem(30)};
    padding-bottom: ${rem(10)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;

export const SectionDescription = styled.div`
    padding-top: ${rem(15)};
    color: ${({ theme }) => theme.colors.grey};
    line-height: ${rem(30)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(30)};
    margin-bottom: ${rem(35)};
`;

export const SectionButton = styled.div`
    margin-top: auto;
`;
